import {useBoardConfig} from './provider/contexts'
import type {BoardLabels} from './types'

/**
 * The label set the caller passed to `BoardProvider`. Neither package ships a string of
 * its own, so anything that needs one reads it from here.
 */
export function useBoardLabels(): BoardLabels {
  return useBoardConfig().labels
}
